module.exports = __webpack_public_path__ + "static/daiwa-roynet-hotel-4c0b1541f578bc1375302a484f2cd7c7.jpg";